import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { api } from '../lib/api';

export function LogoutPage() {
  const navigate = useNavigate();
  const [done, setDone] = useState(false);

  useEffect(() => {
    let cancelled = false;
    api.post('/api/security/logout')
      .catch(() => {}) // Ignore errors — clear session anyway
      .finally(() => {
        if (!cancelled) {
          setDone(true);
          navigate('/login', { replace: true });
        }
      });
    return () => { cancelled = true; };
  }, [navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#cc0404] mx-auto mb-4" style={{ display: done ? 'none' : 'block' }} />
        <p className="text-gray-600">{done ? 'Redirecting…' : 'Logging out...'}</p>
      </div>
    </div>
  );
}
